import React from 'react'

export default function Textarea({ textareaId, placeholder, defaultValue, disabled, classNames, ...props }) {

    return (
        <textarea id={textareaId} defaultValue={defaultValue} disabled={disabled} {...props} placeholder={placeholder} className={`p-3 placeholder:text-[var(--dark-gray-500)] ${disabled ? "text-[#ccc]" : "text-[var(--primary)]"} text-[18px] w-full bg-white border border-[var(--light-gray)] rounded-[5px] ${classNames}`} />
    )
}
